/*
 *IMPORT
 */
import React, { useState } from "react";
import {
  Flex,
  Text,
  Divider,

} from "@chakra-ui/react";
import plus from "../../assets/svg/plus.svg";
import minus from "../../assets/svg/minus.svg";

function Faq() {
  const [showText, setShowText] = useState(false);
  const [showText1, setShowText1] = useState(false);
  const [showText2, setShowText2] = useState(false);
  const [showText3, setShowText3] = useState(false);
  const [showText4, setShowText4] = useState(false);
  const [showText5, setShowText5] = useState(false);

  const toggleText = () => {
    setShowText(!showText);
  };
  const toggleText1 = () => {
    setShowText1(!showText1);
  };
  const toggleText2 = () => {
    setShowText2(!showText2);
  };
  const toggleText3 = () => {
    setShowText3(!showText3);
  };
  const toggleText4 = () => {
    setShowText4(!showText4);
  };
  const toggleText5 = () => {
    setShowText5(!showText5);
  };

  return (

    <>
      <>
        <Text
          mt="7rem"
          textAlign="center"
          color="rgba(16, 24, 40, 1)"
          fontFamily="Inter"
          fontWeight="600"
          fontSize="40px"
          lineHeight="44px"
          letterSpacing="-0.8px"
        >
          Frequently asked questions
        </Text>
        <Text
          mt=".8rem"
          textAlign="center"
          color="rgba(61, 64, 77, 1)"
          fontFamily="Inter"
          fontWeight="400"
          fontSize="20px"
          lineHeight="30px"
        >
          Everything you need to know about the product and billing.
        </Text>

        <Flex direction="column" mt="3rem" alignItems="center" justifyContent="center">
          <Flex w="70%" direction="column">
            <Flex align="center" justifyContent="space-between">
              <Text color="rgba(16, 24, 40, 1)" fontFamily="Inter" fontWeight="500" fontSize="20px" lineHeight="28px">
                Is there a demo available?
              </Text>
              <img src={showText ? minus : plus} alt="Toggle" onClick={toggleText} style={{ cursor: "pointer" }} />
            </Flex>
            {showText && (
              <Flex
                color="rgba(102, 112, 133, 1)"
                fontFamily="Inter"
                fontWeight="400"
                fontSize="16px"
                lineHeight="24px"
                direction="column"
              >
                <Text>Yes, we offer a 2-day demo for our SMS platform.</Text>
                <Text>You can explore features like bulk messaging, delivery tracking, analytics, and campaign management with full access during the demo period.</Text>
              </Flex>
            )}
            <Divider margin="2rem 0" borderWidth="2px" />
          </Flex>

          <Flex w="70%" direction="column">
            <Flex align="center" justifyContent="space-between">
              <Text color="rgba(16, 24, 40, 1)" fontFamily="Inter" fontWeight="500" fontSize="20px" lineHeight="28px">
                Can I change my plan later?
              </Text>
              <img src={showText1 ? minus : plus} alt="Toggle" onClick={toggleText1} style={{ cursor: "pointer" }} />
            </Flex>
            {showText1 && (
              <Flex color="rgba(102, 112, 133, 1)" fontFamily="Inter" fontWeight="400" fontSize="16px" lineHeight="24px" direction="column">
                <Text>Absolutely! You can upgrade or downgrade your plan at any time directly from your account dashboard.</Text>
                <Text>Changes are applied immediately, and your billing will be prorated accordingly.</Text>
              </Flex>
            )}
            <Divider margin="2rem 0" borderWidth="2px" />
          </Flex>

          <Flex w="70%" direction="column">
            <Flex align="center" justifyContent="space-between">
              <Text color="rgba(16, 24, 40, 1)" fontFamily="Inter" fontWeight="500" fontSize="20px" lineHeight="28px">
                What is your cancellation policy?
              </Text>
              <img src={showText2 ? minus : plus} alt="Toggle" onClick={toggleText2} style={{ cursor: "pointer" }} />
            </Flex>
            {showText2 && (
              <Flex
                color="rgba(102, 112, 133, 1)"
                fontFamily="Inter"
                fontWeight="400"
                fontSize="16px"
                lineHeight="24px"
                direction="column"
              >
                <Text>You can cancel your subscription by informing us at least 30 days in advance, with no cancellation fees.</Text>
                <Text>Services will remain active until the end of the current billing cycle.</Text>
              </Flex>
            )}
            <Divider margin="2rem 0" borderWidth="2px" />
          </Flex>

          <Flex w="70%" direction="column">
            <Flex align="center" justifyContent="space-between">
              <Text color="rgba(16, 24, 40, 1)" fontFamily="Inter" fontWeight="500" fontSize="20px" lineHeight="28px">
                Can other info be added to an invoice?
              </Text>
              <img src={showText3 ? minus : plus} alt="Toggle" onClick={toggleText3} style={{ cursor: "pointer" }} />
            </Flex>
            {showText3 && (
              <Flex color="rgba(102, 112, 133, 1)" fontFamily="Inter" fontWeight="400" fontSize="16px" lineHeight="24px" direction="column">
                <Text>Yes, you can add custom billing details such as your company name, address, tax ID, or purchase order number.</Text>
                <Text>This can be managed easily through the Billing section in your account settings.</Text>
              </Flex>
            )}
            <Divider margin="2rem 0" borderWidth="2px" />
          </Flex>

          <Flex w="70%" direction="column">
            <Flex align="center" justifyContent="space-between">
              <Text color="rgba(16, 24, 40, 1)" fontFamily="Inter" fontWeight="500" fontSize="20px" lineHeight="28px">
                How does billing work?
              </Text>
              <img src={showText4 ? minus : plus} alt="Toggle" onClick={toggleText4} style={{ cursor: "pointer" }} />
            </Flex>
            {showText4 && (
              <Flex color="rgba(102, 112, 133, 1)" fontFamily="Inter" fontWeight="400" fontSize="16px" lineHeight="24px" direction="column">
                <Text>Billing is monthly based on your plan and actual usage (e.g., minutes, SMS, or data).</Text>
                <Text>You will receive an invoice at the start of each billing cycle with a breakdown of your charges.</Text>
              </Flex>
            )}
            <Divider margin="2rem 0" borderWidth="2px" />
          </Flex>

          <Flex w="70%" direction="column">
            <Flex align="center" justifyContent="space-between">
              <Text color="rgba(16, 24, 40, 1)" fontFamily="Inter" fontWeight="500" fontSize="20px" lineHeight="28px">
                How do I change my account email?
              </Text>
              <img src={showText5 ? minus : plus} alt="Toggle" onClick={toggleText5} style={{ cursor: "pointer" }} />
            </Flex>
            {showText5 && (
              <Flex color="rgba(102, 112, 133, 1)" fontFamily="Inter" fontWeight="400" fontSize="16px" lineHeight="24px" direction="column">
                <Text>You can update your account email in the Profile Settings section of your dashboard.</Text>
                <Text>We’ll send a verification link to your new email to confirm the change.</Text>
              </Flex>
            )}
            <Divider margin="2rem 0" borderWidth="2px" />
          </Flex>
        </Flex>
      </>

    </>
  );
}

export default Faq;
